import api from '../utils/api';
import { 
  BulkOperationResult, 
  BulkEpicStatusUpdate, 
  BulkFeatureAssignment, 
  BulkAllocationUpdate,
  ImportType 
} from '../types/bulkOperations';

class BulkOperationsService {
  // Bulk update EPIC status
  async bulkUpdateEpicStatus(data: BulkEpicStatusUpdate): Promise<BulkOperationResult> {
    const response = await api.post('/bulk/epics/status', data);
    return response.data;
  }

  // Bulk assign features
  async bulkAssignFeatures(data: BulkFeatureAssignment): Promise<BulkOperationResult> {
    const response = await api.post('/bulk/features/assign', data);
    return response.data;
  }

  // Bulk update allocations
  async bulkUpdateAllocations(data: BulkAllocationUpdate): Promise<BulkOperationResult> {
    const response = await api.post('/bulk/allocations', data);
    return response.data;
  }

  // Import from file
  async importFromFile(file: File, type: ImportType): Promise<BulkOperationResult> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/bulk/import/${type}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  // Download import template
  async downloadTemplate(type: ImportType): Promise<void> {
    const response = await api.get(`/bulk/template/${type}`, {
      responseType: 'blob',
    });

    // Create download link
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${type}_template.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  // Validate file before upload
  validateFile(file: File): { valid: boolean; error?: string } {
    const maxSize = 10 * 1024 * 1024; // 10MB
    const allowedTypes = [
      'text/csv',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];

    if (file.size > maxSize) {
      return { valid: false, error: 'File size must be less than 10MB' };
    }

    if (!allowedTypes.includes(file.type)) {
      return { valid: false, error: 'Only CSV and Excel files are supported' };
    }

    return { valid: true };
  }
}

export const bulkOperationsService = new BulkOperationsService();